import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { jobseekerApi } from "../service/apis/pages.api";
import Loader from "../common/Loader/loader";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useCustomNavigate } from "../hooks/useCustomNavigate";
import { AppRoute } from "../router/routerConstants";

const JobSeekerScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);
    const [ , setIsLoading] = useState(false);
    const { user } = useSelector((state: RootState) => {
        return state.authSlice;
    });
    const [NavigateTo] = useCustomNavigate();


    const jobSeekerContents = async() => {
        setIsLoading(true);
        try {
            const response = await jobseekerApi();
            setResponseData(response?.pageData?.pageContent);
            setTitleSlug(response?.pageData);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        jobSeekerContents();
    }, []);

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }; 

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    const choose_texts = responseData[7]?.formFieldRepeater;
    const works_texts = responseData[9]?.formFieldRepeater;

    const handleNavigateAccount = () => {
        if (user && user?.role === "jobseeker") {
          NavigateTo(AppRoute.JOBSEEKER_DASHBOARD);
        } else if (user && user?.role === "localagents") {
          NavigateTo(AppRoute.AGENT_DASHBOARD);
        } else if (user && user?.role === "employer") {
          NavigateTo(AppRoute.EMPLOYER_DASHBOARD);
        }else{
            NavigateTo(AppRoute.JOBSEEKER_REGISTER)
        }
    };

    return (
        <>
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="aboutpagetop-area position-relative common-padd-xl">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 order-2">
                                <div className="aboutpagetop-info employertopinfo">
                                    {responseData[3]?.type === "text" && responseData[3]?.content && (
                                        <h2>{responseData[3]?.content}</h2>
                                    )}
                                    {responseData[4]?.type === "editor" && responseData[4]?.content && (
                                        sanitizeData(responseData[4]?.content)
                                    )}
                                    <Button onClick={() => handleNavigateAccount()} className="btn">{responseData[5]?.content}</Button>
                                </div>
                            </div>
                            <div className="col-lg-6 bundle-flex-left">
                                <div className="bundleImg-holder">
                                    <div className="row align-items-end mb-4">
                                        <div className="col-lg-6">
                                            <div className="galleryImg2"><img src={responseData[0]?.content} alt="img 2" /></div>
                                        </div>
                                        <div className="col-lg-6"><div className="galleryImg1"><img src={responseData[1]?.content} alt="img 1" /></div></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12"><div className="galleryImg3"><img src={responseData[2]?.content} alt="img 3" /></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="corevalues-area common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <h2>{sanitizeData(responseData[6]?.content)}</h2>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            {choose_texts ? ( choose_texts.map((choose: any, index: any) => (
                                <div key={index} className="col-lg-4">
                                    <div className="corevaluesCard text-center">
                                        <div className="categoryIcon"><img src={choose[1]?.content} alt={choose[0]?.content} /></div>
                                        <h4>{choose[0]?.content}</h4>
                                        {choose[2]?.content}
                                    </div>
                                </div>
                                ))
                            ) : (
                                <Loader/>
                            )}
                        </div>
                    </div>
                </section>

                <section className="howitworks-area common-padd-xl pt-8">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <h2>{sanitizeData(responseData[8]?.content)}</h2>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            {works_texts ? ( works_texts.map((wrk: any, index: any) => (
                                <div key={index} className="col-lg-4">
                                    <div className="corevaluesCard">
                                        <div className="iconnumberholder">
                                            <div className="categoryIcon"><img src={wrk[1]?.content} alt={wrk[0]?.content} /></div>
                                            <div className="numbercount">{String(index + 1).padStart(2, '0')}</div>
                                        </div>
                                        <h4>{wrk[0]?.content}</h4>
                                        {wrk[2]?.content}
                                    </div>
                                </div>
                                ))
                            ) : (
                                <Loader/>
                            )}

                        </div>
                    </div>
                </section>

                <section className="brandlogo-area connectnow common-padd-small mb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 brandlogo-title text-center">
                                <h2>{responseData[10]?.content}</h2>
                                {sanitizeData(responseData[11]?.content)}
                                <Button onClick={() => handleNavigateAccount()} className="btn btn-white">{responseData[12]?.content}</Button>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}
export default JobSeekerScreen;